<script module lang="ts">
  import { css } from "@agapi/ui/panda/css";
  import { stack } from "@agapi/ui/panda/patterns";
  import { CheckCircle } from "phosphor-svelte";
  import DynamicIcon from "../../../components/dynamic-icon/dynamic-icon.svelte";
  import * as m from '$lib/parachute/messages';

  export interface ProductInfoUspsProps {
    usps: {
      label: string;
      icon: 'award' | 'chat' | 'bulb' | 'star' | 'heart' | 'shield' | 'check' | 'check-circle' | 'leaf' | 'flower' | 'tree' | 'sun' | 'moon' | 'cloud' | 'phone';
    }[];
  }
</script>

<script lang="ts">

  const { usps }: ProductInfoUspsProps = $props();
</script>

<div class={stack({ flexDirection: 'row', columnGap: '3', rowGap: '2', flexFlow: 'column', flexWrap: 'wrap' })}>
  {#each usps as usp}
    <span class={css({ fontSize: 'sm', color:'text.vibrant', flexDirection: 'row', display: 'flex', gap: '1', alignItems: 'center', justifyContent: 'center', fontWeight: 'medium' })}>
      <DynamicIcon name={usp.icon} />
      {usp.label}
    </span>
  {/each}
</div>
